import React from 'react';
import { CopyButton } from '@components/common/CopyButton';
import { ButtonClean, ConfirmModal, Icon, Loading, useModalContext } from '@fourthwall/components';
import { SpotifyIcon } from '@fourthwall/icons';
import * as S from './SyncedBar.styled';
export const SyncedBar = ({ url, errored, loading, onClick }) => {
    const modal = useModalContext();
    return (React.createElement("div", { style: { width: '100%' } },
        React.createElement(Loading, { isLoading: loading },
            React.createElement(S.Container, null,
                React.createElement(S.IconContainer, null,
                    React.createElement(Icon, { component: SpotifyIcon, height: 20 })),
                React.createElement("div", null,
                    React.createElement(S.Status, null,
                        React.createElement(S.Title, null, errored ? 'Sync failed' : 'Synced to Spotify'),
                        React.createElement(ButtonClean, { label: "Disconnect", withUnderline: true, onClick: () => {
                                modal.open(ConfirmModal, {
                                    title: 'Disconnect from Spotify?',
                                    text: 'Your podcast be removed from Spotify and it will no longer be synced.  ',
                                    confirmLabel: 'Disconnect',
                                    confirmAppearance: 'destructive',
                                    onConfirm: onClick,
                                });
                            } })),
                    React.createElement(S.CopyWrapper, null,
                        React.createElement(CopyButton, { appearance: "secondary", href: url, label: url, copyLabel: "Copy link", copyText: url })))))));
};
